// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats_stats__oQTXL","title":"Stats_title__cA5Zq","stats__list":"Stats_stats__list__aHAss"};